import React from 'react';
import { Sun, Cloud, CloudSun, CloudRain, CloudDrizzle, CloudLightning, Snowflake, CloudFog } from 'lucide-react';

const iconFor = (code) => {
  if (code == null) return Cloud;
  if (code === 0) return Sun;
  if (code <= 2) return CloudSun;
  if (code === 3) return Cloud;
  if (code <= 48) return CloudFog;
  if (code <= 57) return CloudDrizzle;
  if (code <= 67 || (code >= 80 && code <= 82)) return CloudRain;
  if (code <= 77 || (code >= 85 && code <= 86)) return Snowflake;
  return CloudLightning;
};

export function WeatherChip({ w, compact }) {
  const Icon = iconFor(w.code);
  const rain = w.rain_prob ?? 0;
  const tone = rain >= 60 ? 'bg-sky-100 text-sky-900 border-sky-300' : rain >= 30 ? 'bg-slate-100 text-slate-700 border-slate-200' : 'bg-amber-50 text-amber-800 border-amber-200';
  const title = `${w.postcode} · ${rain}% chance of rain${w.rain_mm != null ? ` · ${w.rain_mm}mm` : ''} · ${Math.round(w.tmin)}–${Math.round(w.tmax)}°C${rain >= 60 ? ' — avoid laying resin' : ''}`;
  return (
    <span title={title} data-testid="weather-chip" className={`inline-flex items-center gap-0.5 rounded-full border px-1 leading-4 ${compact ? 'text-[9px]' : 'text-[10px]'} font-semibold ${tone}`}>
      <Icon className={compact ? 'w-2.5 h-2.5' : 'w-3 h-3'} />
      {rain}%{!compact && w.tmax != null ? ` · ${Math.round(w.tmax)}°` : ''}
    </span>
  );
}
